import { twMerge } from 'tailwind-merge';

import { QuerySearchResults } from '@/sections/insights/queryBuilder/components/QueryBuilderSidebar/QuerySearchResults';
import { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

export interface QuerySearchDropdownProps {
  /** Whether dropdown is open */
  isOpen: boolean;
  /** Search results to display */
  results: SavedQuery[];
  /** Search query for empty state */
  searchQuery: string;
}

/**
 * QuerySearchDropdown - Animated dropdown container for search results
 *
 * Features:
 * - CSS Grid animation (grid-rows-[0fr/1fr])
 * - Wraps QuerySearchResults component
 * - Smooth expand/collapse transition
 *
 * Pattern verified from QueryFolder.tsx:64-70
 *
 * @example
 * ```tsx
 * <QuerySearchDropdown
 *   isOpen={searchQuery.length > 0}
 *   results={filteredQueries}
 *   searchQuery={searchQuery}
 * />
 * ```
 */
export const QuerySearchDropdown = ({
  isOpen,
  results,
  searchQuery,
}: QuerySearchDropdownProps) => {
  return (
    <div
      className={twMerge(
        'grid transition-[grid-template-rows,opacity] duration-300 ease-in-out',
        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      )}
      data-testid="query-search-dropdown"
    >
      <div className="overflow-hidden">
        <QuerySearchResults results={results} searchQuery={searchQuery} />
      </div>
    </div>
  );
};
